"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isSubscriptionRollout(object) {
    return checkSubscriptionRollout(object).fulfilled;
}
exports.isSubscriptionRollout = isSubscriptionRollout;
function checkSubscriptionRollout(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("companyId")).withOptions(options).explain();
}
exports.checkSubscriptionRollout = checkSubscriptionRollout;
//# sourceMappingURL=SubscriptionRollout.js.map